export const REGEXES = {
  textWithCommonSymbols:
    /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9&.,'*!-]*(\x20[\u4e00-\u9fa5a-zA-Z0-9&.,'*!-]+)*$/,
};
